import { useDispatch, useSelector } from 'react-redux';
import { UserNotice } from './reducer';
import { getUserNotices } from './selectors';
import { setUserNotice } from './actions';

export const useUserNotice = (notice: UserNotice) => {
  const dispatch = useDispatch();

  const notices = useSelector(getUserNotices);

  const currentValue = notices[notice];

  const setNoticeValue = (value: boolean) => {
    dispatch(setUserNotice({ type: notice, value }));
  };

  return {
    value: currentValue,
    setValue: setNoticeValue,
  };
};



// WEBPACK FOOTER //
// ./src/containers/UserProfile/UserNoticeHook.ts